import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfig = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'APPLICATIONS',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'applications',
        title: 'Applications',
        type: 'item',
        icon: 'apps',
        url: '/applications'
      },
      {
        id: 'users',
        title: 'Users',
        type: 'item',
        icon: 'person',
        url: '/users'
      },
      {
        id: 'audit',
        title: 'Audit',
        type: 'collapse',
        icon: 'security',
        children: [
          {
            id: 'access-history',
            title: 'Access History',
            type: 'item',
            url: '/access-history',
            icon: 'access_time'
          },
          {
            id: 'roles',
            title: 'Role Audit',
            type: 'item',
            url: '/roles',
            icon: 'group'
          }
        ]
      },
      {
        id: 'identityServer',
        title: 'Identity Server',
        type: 'collapse',
        icon: 'settings',
        children: [
          {
            id: 'clients',
            title: 'Clients',
            type: 'item',
            icon: 'vpn_key',
            url: '/clients'
          }
        ]
      },
      {
        id: 'translations',
        title: 'Translations',
        type: 'item',
        icon: 'translate',
        url: '/translations'
      }
    ]
  }
];

export default navigationConfig;
